import { render } from "./HowToPlay.vue?vue&type=template&id=3082b951&ts=true"
import script from "./HowToPlay.vue?vue&type=script&lang=ts"
export * from "./HowToPlay.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__